import React from 'react';
import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormField,
  SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  searchFieldState: {
    selectedDebitAccount: AccountModel | null;
    setSelectedDebitAccount: (account: AccountModel | null) => void;
  };
}

const BasicInfoTab = ({ searchFieldState }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-[150px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeField
          label='Ngày c/từ (từ/đến)'
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-44'
          fromFieldClassName='w-44'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeField label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      <div className='flex items-center'>
        <Label className='w-[150px]'>Loại xuất</Label>
        <div className='w-[210px]'>
          <FormField
            name='ma_ngv'
            type='select'
            options={[
              { label: 'Tất cả', value: 'ALL' },
              { label: '1. Thu theo hóa đơn', value: '1' },
              { label: '2. Thu theo đối tượng', value: '2' },
              { label: '3. Thu khác', value: '3' },
              { label: '4. Rút tiền về nhập quỹ', value: '4' },
              { label: '6. Bán hàng thu tiền ngay', value: '6' }
            ]}
          />
        </div>
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản nợ</Label>
        <SearchField<AccountModel>
          type='text'
          name='tk'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={searchFieldState.selectedDebitAccount?.code}
          relatedFieldValue={searchFieldState.selectedDebitAccount?.name}
          onRowSelection={searchFieldState.setSelectedDebitAccount}
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
